import { ApolloQueryResult, useMutation } from '@apollo/client';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Fade,
  IconButton,
  Modal,
  Typography,
} from '@material-ui/core';
import { Close, Delete } from '@material-ui/icons';

import { Toast } from '../../../../components/Toast';
import { DELETE_TAG } from '../../../../queries/tag';
import { ITag } from '../../../../typings/tag';
import { getFriendlyErrorMessage } from '../../../../utils/errorHelper';
import useStyles from '../../styles';

interface IDeleteTagModal {
  isOpened: boolean
  handleClose: () => void
  tag?: ITag
  refetchList: (
    variables?: {
      listTags: ITag[]
    } | undefined
  ) => Promise<ApolloQueryResult<any>>
}

const DeleteTagModal: React.FC<IDeleteTagModal> = ({
  isOpened,
  handleClose,
  tag,
  refetchList,
}) => {
  const [selectedTag, setSelectedTag] = useState<ITag | undefined>();
  const classes = useStyles();

  const [deleteTag] = useMutation(DELETE_TAG);

  useEffect(() => {
    if (tag) {
      setSelectedTag(tag);
    }
  }, [tag]);

  const handleSave = async () => {
    try {
      await deleteTag({
        variables: {
          id: selectedTag?.id,
        },
      });

      refetchList();
      handleClose();
      Toast(`Tag: ${selectedTag?.name} was deleted!`);
    } catch (error) {
      Toast(getFriendlyErrorMessage(error), 'error');
    }
  };

  return (
    <Modal open={isOpened} onClose={handleClose} className={classes.modal}>
      <Fade in={isOpened}>
        <Box className={classes.modalPaper}>
          <Box className={classes.modalHeader}>
            <Box className={classes.modalHeaderSide} />
            <Box className={classes.modalHeaderCenter}>
              <Typography align="center" variant="h4">
                Do you want to delete this tag?
                <br />
                <br />
                <b>Name:</b>
                {' '}
                {selectedTag?.name}
              </Typography>
            </Box>
            <Box
              className={clsx(
                classes.modalHeaderSide,
                classes.modalCloseContainer,
              )}
            >
              <Box className={classes.modalClose}>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Button
            variant="contained"
            color="primary"
            className={classes.saveButton}
            onClick={handleSave}
            startIcon={<Delete />}
          >
            Delete
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default DeleteTagModal;
